<template>
  <div class="test-item">
    <div class="test-item-tigan">
      <div class="test-item-tigan-html" v-html="data.questionBody"></div>
      <div v-if="showSound==true&&data.questionSound"><span class="icon iconfont iconyinpin hand"
                                                            @click=playSound(data.questionSound)></span></div>
      <slot name="toolbar"></slot>
    </div>
    <audio :src="data.questionSound" :id="'test'+data.questionId"></audio>
    <div v-for="(item,index) in data.modelList">
      <div>
        <TestItemSingle :test-index="item.sort" :test-point="0" :data=item :show-answer="showAnswer" :show-timer="false"
                          :show-resolve="showResolve" :show-sound="showSound"></TestItemSingle>
      </div>
    </div>
    <div class="test-item-createtime" v-if="showTimer">创建于:{{data.createTimeStr}}</div>
  </div>
</template>

<script>
  import TestItemSingle from './TestItemSingle.vue';
  export default {
    name: 'TestItemComplex',
    components: {
      TestItemSingle: TestItemSingle,
    },
    props: {
      data: {
        required: true
      },
      showAnswer: {
        type: Boolean,
        default: true
      },
      showResolve: {
        type: Boolean,
        default: true
      },
      showTimer: {
        type: Boolean,
        default: true
      },
      showSound: {
        type: Boolean,
        default: false
      },
      testIndex: {
        type: Number,
        default: 0
      },
      testPoint: {
        type: Number,
        default: 0
      }
    },
    methods: {
      playSound(val) {
        var audio = document.getElementsByTagName('audio');
        for (var i = 0; i < audio.length; i++) {
          audio[i].pause();
        }
        let player = document.querySelector('#test' + this.data.questionId);
        if (player.paused) {
          player.play();
        } else {
          player.pause();
        }
      }
    },
    created() {

      //var questionBody = decodeURIComponent(this.data.questionBody);
      for (var i = 0; i < this.data.modelList.length; i++) {
        //this.data.modelList[i].questionBody = decodeURIComponent(this.data.modelList[i].questionBody)
        this.data.modelList[i].questionBody = this.data.modelList[i].questionBody;
      }

      if (this.data.questionBody) {
        var questionBody = decodeURIComponent(this.data.questionBody);
        var index = this.testIndex <= 0 ? '' : this.testIndex + '. ';
        var point = this.testPoint <= 0 ? '' : '（' + this.testPoint + '分）';
        this.data.questionBody = index + point + questionBody;
      }

    }
  };
</script>

<style scoped>

</style>
